function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState, useRef, useCallback } from 'react';
import classnames from 'classnames';
import { Icon } from "../../Icon/Icon/Icon";
import Utility from "../../Utility/Utility";
import styles from "./AnimationVideo.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var animationVideoDefaultProps = {
  alt: '',
  playTitle: 'Play video',
  pauseTitle: 'Pause video'
};
export var AnimationVideo = function AnimationVideo(_ref) {
  var _videoAttributes$auto2, _videoAttributes$auto3;
  var originalSources = _ref.sources,
    poster = _ref.poster,
    width = _ref.width,
    height = _ref.height,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'none' : _ref$align,
    padding = _ref.padding,
    videoAttributes = _ref.videoAttributes,
    onPlay = _ref.onPlay,
    onPause = _ref.onPause,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? animationVideoDefaultProps.alt : _ref$alt,
    _ref$playTitle = _ref.playTitle,
    playTitle = _ref$playTitle === void 0 ? animationVideoDefaultProps.playTitle : _ref$playTitle,
    _ref$pauseTitle = _ref.pauseTitle,
    pauseTitle = _ref$pauseTitle === void 0 ? animationVideoDefaultProps.pauseTitle : _ref$pauseTitle;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showControls = _useState2[0],
    setShowControls = _useState2[1];
  var videoId = useRef(Utility.generateUID('animation-video')).current;
  var screenReaderId = useRef(Utility.generateUID('animation-video-screenreader')).current;
  var vidRef = useRef(null);
  var playButtonRef = useRef(null);
  var pauseButtonRef = useRef(null);
  var isPlayingRef = useRef(true);
  var updatePlayPause = useCallback(function () {
    if (!playButtonRef || !playButtonRef.current || !pauseButtonRef || !pauseButtonRef.current || !vidRef.current) {
      return;
    }
    if (isPlayingRef.current) {
      playButtonRef.current.classList.add(styles['hidden']);
      pauseButtonRef.current.classList.remove(styles['hidden']);
      playButtonRef.current.setAttribute('aria-pressed', 'true');
      pauseButtonRef.current.setAttribute('aria-pressed', 'false');
      vidRef.current.play();
    } else {
      playButtonRef.current.classList.remove(styles['hidden']);
      pauseButtonRef.current.classList.add(styles['hidden']);
      playButtonRef.current.setAttribute('aria-pressed', 'false');
      pauseButtonRef.current.setAttribute('aria-pressed', 'true');
      vidRef.current.pause();
    }
  }, []); // Empty dependency array since we're using refs

  var snapVideoToWholePixels = useCallback(function () {
    try {
      var video = vidRef.current;
      if (video && video.offsetWidth && video.offsetHeight && video.videoWidth && video.videoHeight && video.style) {
        // Reset styles to allow intrinsic size recalculation
        video.style.width = '';
        video.style.height = '';
        var currentWidth = video.offsetWidth;
        var currentHeight = video.offsetHeight;

        // Get the video's intrinsic (native) aspect ratio
        var intrinsicWidth = video.videoWidth;
        var intrinsicHeight = video.videoHeight;
        var aspectRatio = intrinsicWidth / intrinsicHeight;

        // Ensure aspectRatio is valid before proceeding
        if (!isFinite(aspectRatio) || aspectRatio <= 0) {
          console.warn('Invalid aspect ratio detected. Skipping resizing.');
          video.style.width = "".concat(currentWidth, "px");
          video.style.height = "".concat(currentHeight, "px");
          return;
        }
        var wholeWidth = Math.round(currentWidth);
        var wholeHeight = Math.round(wholeWidth / aspectRatio);

        // Adjust height to be a whole number, prioritizing width if needed
        if (Math.abs(wholeHeight - currentHeight) > Math.abs(wholeWidth / aspectRatio - currentHeight) + 0.001) {
          wholeHeight = Math.round(wholeWidth / aspectRatio);
        } else {
          wholeWidth = Math.round(wholeHeight * aspectRatio);
        }
        video.style.width = "".concat(wholeWidth, "px");
        video.style.height = "".concat(wholeHeight, "px");
      }
    } catch (error) {
      console.error('Error snapping video to whole pixels:', error);
    }
  }, []);

  // Initialize video and button states on mount
  useEffect(function () {
    var _videoAttributes$auto;
    var shouldAutoPlay = (_videoAttributes$auto = videoAttributes === null || videoAttributes === void 0 ? void 0 : videoAttributes.autoPlay) !== null && _videoAttributes$auto !== void 0 ? _videoAttributes$auto : true;
    isPlayingRef.current = shouldAutoPlay;
    updatePlayPause();
    snapVideoToWholePixels();

    // Adjust video dimensions on window resize
    window.addEventListener('resize', snapVideoToWholePixels);
    return function () {
      window.removeEventListener('resize', snapVideoToWholePixels);
    };
  }, [videoAttributes === null || videoAttributes === void 0 ? void 0 : videoAttributes.autoPlay, updatePlayPause, snapVideoToWholePixels]);
  var playVideo = function playVideo() {
    isPlayingRef.current = true;
    if (onPlay) {
      onPlay();
    }
    updatePlayPause();
  };
  var pauseVideo = function pauseVideo() {
    isPlayingRef.current = false;
    if (onPause) {
      onPause();
    }
    updatePlayPause();
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (isPlayingRef.current) {
        pauseVideo();
      } else {
        playVideo();
      }
    }
  };
  var containerStyles = {
    maxWidth: width ? "".concat(width, "px") : undefined,
    maxHeight: height ? "".concat(height, "px") : undefined,
    padding: padding ? padding : undefined
  };
  var sources = originalSources ? originalSources.map(function (source) {
    return Object.assign({}, source, {
      src: Utility.getOptimizedCloudinaryUrl(source.src, {
        width: width,
        height: height
      })
    });
  }) : originalSources;
  var mainSource = sources && sources[0] && sources[0].src ? sources[0].src : null;
  var videoKey = mainSource ? mainSource : 'no-video';
  var defaultVideoAttributes = {
    autoPlay: true,
    controls: false,
    loop: true,
    muted: true,
    playsInline: true
  };
  var attributes = Object.assign({}, _objectSpread(_objectSpread({}, defaultVideoAttributes), {}, {
    poster: poster || undefined
  }), videoAttributes);

  // Determine initial aria-pressed state based on autoPlay
  var initialPlayPressed = (_videoAttributes$auto2 = videoAttributes === null || videoAttributes === void 0 ? void 0 : videoAttributes.autoPlay) !== null && _videoAttributes$auto2 !== void 0 ? _videoAttributes$auto2 : defaultVideoAttributes.autoPlay;
  var initialPausePressed = !((_videoAttributes$auto3 = videoAttributes === null || videoAttributes === void 0 ? void 0 : videoAttributes.autoPlay) !== null && _videoAttributes$auto3 !== void 0 ? _videoAttributes$auto3 : defaultVideoAttributes.autoPlay);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, {
      [styles.alignLeft]: align === 'left',
      [styles.alignCenter]: align === 'center',
      [styles.alignRight]: align === 'right'
    }),
    style: containerStyles,
    onMouseEnter: function onMouseEnter() {
      return setShowControls(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setShowControls(false);
    },
    onFocus: function onFocus() {
      return setShowControls(true);
    },
    onBlur: function onBlur() {
      return setShowControls(false);
    },
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/_jsx("video", _objectSpread(_objectSpread({
      ref: vidRef,
      className: styles.video,
      id: videoId,
      "aria-describedby": alt ? screenReaderId : undefined
    }, attributes), {}, {
      children: sources && sources.map(function (source, key) {
        return /*#__PURE__*/_jsx("source", {
          src: source.src,
          type: source.type
        }, key);
      })
    }), videoKey), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.buttonWrapper, {
        [styles.show]: showControls
      }),
      children: [/*#__PURE__*/_jsx("button", {
        ref: playButtonRef,
        className: styles.button,
        onClick: playVideo,
        title: playTitle,
        "aria-controls": videoId,
        "aria-label": playTitle,
        "aria-pressed": initialPlayPressed,
        children: /*#__PURE__*/_jsx(Icon, {
          width: "25px",
          type: "play-background-video"
        })
      }), /*#__PURE__*/_jsx("button", {
        ref: pauseButtonRef,
        className: styles.button,
        onClick: pauseVideo,
        title: pauseTitle,
        "aria-controls": videoId,
        "aria-label": pauseTitle,
        "aria-pressed": initialPausePressed,
        children: /*#__PURE__*/_jsx(Icon, {
          width: "25px",
          type: "pause-background-video"
        })
      })]
    }), alt && /*#__PURE__*/_jsx("div", {
      id: screenReaderId,
      className: styles.screenReader,
      children: alt
    })]
  });
};